export const COS_CDN_BASE = 'https://pet-cdn.wxmini.club';
export const COS_ORIGIN_BASE = 'https://pet-1252828110.cos.ap-guangzhou.myqcloud.com';

// 默认使用 CDN 域名
export const COS_BASE_URL = COS_CDN_BASE;

export const getCosImageUrl = (folder: string, filename: string) => {
  return `${COS_BASE_URL}/${encodeURIComponent(folder)}/${filename}`;
};

/**
 * 将 CDN URL 转换为源站 URL
 */
export const getOriginUrl = (url: string) => {
  if (!url) return url;
  if (url.startsWith(COS_CDN_BASE)) {
    return url.replace(COS_CDN_BASE, COS_ORIGIN_BASE);
  }
  return url;
};
